"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var MarkupResource = /** @class */ (function (_super) {
    tslib_1.__extends(MarkupResource, _super);
    function MarkupResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkupResource.endpoint = '/markups';
    MarkupResource.MODEL_NAME = 'markup';
    return MarkupResource;
}(base_1.default));
exports.default = MarkupResource;
//# sourceMappingURL=markup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/markup.js
// module id = mu0E
// module chunks = 0